import React, {
  ChangeEvent,
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
} from "react";
import { Link, useParams } from "react-router-dom";
import CommonDropdownMenuThree from "../Shared/CommonDropdownMenuThree";
import CommonDropdownMenufour from "../Shared/CommonDropdownMenufour";
import "./CreateInvoice.css";
import UnitOption from "./UnitOption";
import axios from "axios";

const CreateInvoiceContent = React.forwardRef((props, ref) => {
  const options = ["Custom Date", "Smart date"];
  const options_sub = [
    "Payment is due on a fixed calendar date",
    "Payment due date is based on event or invoice date",
  ];
  const options2 = ["day(s)", "Week(s)", "month(s)"];
  const options3 = ["before event date", "after event date"];

  const { invoiceId, code: shareCode } = useParams();
  // State variables
  const [services, setServices] = useState([]);
  const [showDueDateBox, setShowDueDateBox] = useState(null);
  const [isSelectItemBoxOpen, setIsSelectItemBoxOpen] = useState(false);
  const selectItemBoxRef = useRef(null);
  const [showTaxBox, setShowTaxBox] = useState(false);
  const [showDiscountBox, setShowDiscountBox] = useState(false);
  const [subtotalprice, setsubtotalprice] = useState(0);
  const [totalprice, settotalprice] = useState(0);
  const [tax, settax] = useState(0);
  const [taxval, settaxval] = useState(0);
  const [taxper, settaxper] = useState(false);
  const [discount, setdiscount] = useState(0);
  const [discountval, setdiscountval] = useState(0);
  const [discountper, setdiscountper] = useState(false);

  const [pakagesdetails, setpakagesdetails] = useState([]);

  const [itemdetails, setitemdetails] = useState([]);

  const [smartdate, setsmartdate] = useState(false);
  const [smartday, setsmartday] = useState("");
  const [smartmonth, setsmartmonth] = useState(false);
  const [smartyear, setsmartyear] = useState(false);

  const [code, setcode] = useState(0);

  const [partialfriction, setpartialfriction] = useState(10);

  const [companylogo, setCompanylogo] = useState();
  const [secondarylogo, setSecondarylogo] = useState();
  const [phone, setPhone] = useState();
  const [companyemail, setCompanyemail] = useState();
  const [fname, setFname] = useState();
  const [lname, setLname] = useState();
  const [companyname, setcompanyname] = useState();

  const [username, setusername] = useState("");
  const [useremail, setuseremail] = useState("");
  const [customername, setcustomername] = useState("");
  const [customeremail, setcustomeremail] = useState("");

  const [payments, setPayments] = useState([
    {
      amount: totalprice,
      dueDate: new Date().toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      }),
      paymentId: "Due Today",
    },
  ]);

  const ref2 = useRef([]);

  const handleInput = (e, index) => {
    if (ref2.current[index]) {
      ref2.current[index].style.height = "auto";
      ref2.current[index].style.height = `${
        ref2.current[index].scrollHeight + 16
      }px`;
    }
  };

  useEffect(() => {
    const fetchpakages = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/packages`
        );
        response.data.forEach((tabs1, index) => {
          const pakagesdetail = {
            id: tabs1.id,
            name: tabs1.name,
            price: tabs1.price,
            description: tabs1.description,
            quantity: tabs1.quantity,
            tax: tabs1.tax,
            unit_option: tabs1.unit_option,
          };
          setpakagesdetails((pakagesdetails) => [
            ...pakagesdetails,
            pakagesdetail,
          ]);

          // Use functional update for setTabs to ensure latest state
        });
      } catch (error) {
        console.error("Error fetching contract:", error);
      }
    };

    const fetchproducts = async () => {
      try {
        const productresponse = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/products`
        );
        productresponse.data.forEach((tabs1, index) => {
          const itemdetail = {
            id: tabs1.id,
            name: tabs1.name,
            price: tabs1.price,
            description: tabs1.description,
            quantity: tabs1.quantity,
            tax: tabs1.tax,
            unit_option: tabs1.unit_option,
          };
          setitemdetails((itemdetails) => [...itemdetails, itemdetail]);

          // Use functional update for setTabs to ensure latest state
        });
      } catch (error) {
        console.error("Error fetching contract:", error);
      }
    };
    fetchpakages();
    fetchproducts();

    const fetchContract = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/sharedinvoice/${invoiceId}/${shareCode}`
        );
        setServices(JSON.parse(response.data.sharedinvoice.items));
        setPayments(JSON.parse(response.data.sharedinvoice.payment));
        setusername(response.data.sharedinvoice.customer_name);
        const userIdFromInvoice = response?.data?.sharedinvoice?.user_id;
        if (userIdFromInvoice) {
          localStorage.setItem("shared_user_id", userIdFromInvoice);
        }

        setcode(response.data.sharedinvoice.code);
        if (response.data.sharedinvoice.taxper != 0) {
          settaxper(true);
          settax(response.data.sharedinvoice.tax);
        } else {
          settaxper(false);
          settax(response.data.sharedinvoice.tax);
        }
        if (response.data.sharedinvoice.discountper != 0) {
          setdiscountper(true);
          setdiscount(response.data.sharedinvoice.discount);
        } else {
          setdiscountper(false);
          setdiscount(response.data.sharedinvoice.discount);
        }
      } catch (error) {
        console.error("Error fetching contract:", error);
      }
    };
    fetchContract();

    // If user detail is passed as prop, use it directly instead of making authenticated API call
    if (props.userDetail) {
      const userDetails = props.userDetail;
      setCompanylogo(
        userDetails.Main_Logo
          ? process.env.REACT_APP_BACKEND_URL + userDetails.Main_Logo
          : null
      );
      setSecondarylogo(
        userDetails.Secondary_Logo
          ? process.env.REACT_APP_BACKEND_URL + userDetails.Secondary_Logo
          : null
      );
      setPhone(userDetails.Phone_Number);
      setCompanyemail(userDetails.Company_Email);
      setFname(userDetails.first_name);
      setLname(userDetails.last_name);
      setcompanyname(userDetails.companyname);
    } else {
    const fetchuserdata = async () => {
      try {
        let userId = null;

        const storedUser = localStorage.getItem("user");
        if (storedUser) {
          try {
            const parsedUser = JSON.parse(storedUser);
            userId = parsedUser?.user?.id;
          } catch (e) {
            console.error("Invalid user JSON in localStorage", e);
          }
        }

        // Fallback to shared_user_id if main user is not found
        if (!userId) {
          userId = localStorage.getItem("shared_user_id");
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/userdetaila/${userId}`
        );

        const userDetails = response.data.usersdetails?.[0];
        if (userDetails) {
          setCompanylogo(
            userDetails.Main_Logo
              ? process.env.REACT_APP_BACKEND_URL + userDetails.Main_Logo
              : null
          );

          setSecondarylogo(
            userDetails.Secondary_Logo
              ? process.env.REACT_APP_BACKEND_URL + userDetails.Secondary_Logo
              : null
          );

          setPhone(userDetails.Phone_Number);
          setCompanyemail(userDetails.Company_Email);
          setFname(userDetails.first_name);
          setLname(userDetails.last_name);
          setcompanyname(userDetails.companyname);
        }
      } catch (error) {
        console.error("Error fetching contract:", error);
      }
    };
    fetchuserdata();
    }
  }, [props.userDetail]);

  useEffect(() => {
    // useLayoutEffect TO AVOID FLICKERING
    ref2.current.map((tab, index) => {
      if (ref2.current[index]) {
        ref2.current[index].style.height = "auto";
        ref2.current[index].style.height = `${
          ref2.current[index].scrollHeight + 16
        }px`;
      }
    });

    // NEEDS TO ADD 2. I THINK IT'S BECAUSE OF THE BORDER
  }, [services]);

  useEffect(() => {
    if (!invoiceId) {
      setServices([
        ...services,
        {
          showServiceInfo: false,
          qty: 0,
          unit_option: "Item",
          tax: false,
          price: 0,
          itemtotalprice: 0,
          type: "",
          descp: "",
        },
      ]);
    }
  }, []);

  useEffect(() => {
    setsubtotalprice(10);
  }, []);
  /*
    useEffect(() => {
                        if(props.items){
                                          props.items.forEach((tabs1, index) => {
                                                                        setServices([
                                                                          ...services,
                                                                          {
                                                                            showServiceInfo: false,
                                                                            qty:tabs1.qty,
                                                                            unit:"",
                                                                            tax:false,
                                                                            price:tabs1.price,
                                                                            itemtotalprice:0,
                                                                            type:"",
                                                                            desc:"",
                                                                          },
                                                                        ])
                                                    });
                        }
  
                        if(props.invoicepayments){
                          
                          props.invoicepayments.forEach((tabs1, index) => {
                                                        setPayments([
                                                          ...payments,
                                                          {
                                                            amount:10,
                                                            dueDate:tabs1.dueDate,
                                                            paymentId:tabs1.paymentId,
                                                          },
                                                        ])
                                    });
                         }
  
                        
    }, [props.items,props.invoicepayments]);
  
    */

  useImperativeHandle(ref, () => ({
    getMyservices: () => {
      return services;
    },
    getTotalpayment: () => {
      return totalprice;
    },
    getPayments: () => {
      return payments;
    },
    getTaxper: () => {
      return taxper;
    },
    getTax: () => {
      return tax;
    },
    getDiscountper: () => {
      return discountper;
    },
    getDiscount: () => {
      return discount;
    },
  }), [services, totalprice, payments, taxper, tax, discountper, discount]);

  // const [selectedDueDate, setSelectedDueDate] = useState("");

  // Current date setup
  const currentDate = new Date();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const formattedDate = `${
    months[currentDate.getMonth()]
  } ${currentDate.getDate()}, ${currentDate.getFullYear()}`;

  // Functions to handle toggling of various components
  const toggleHandleServiceInfo = (index) => {
    const updatedServices = [...services];
    updatedServices[index].showServiceInfo =
      !updatedServices[index].showServiceInfo;
    setServices(updatedServices);
    setIsSelectItemBoxOpen(!isSelectItemBoxOpen);
  };
  // Handle add new service
  const addNewService = () => {
    setServices([
      ...services,
      {
        showServiceInfo: false,
        qty: 1,
        unit_option: "Item",
        tax: false,
        price: 0,
        itemtotalprice: 0,
        type: "",
        descp: "",
      },
    ]); // Add a new empty service object
  };

  // Functions to handle toggling of various components
  const toggleTaxBox = () => {
    setShowTaxBox(!showTaxBox);
    setShowDiscountBox(false);
  };
  // Functions to handle toggling of various components
  const toggleDiscountBox = () => {
    setShowDiscountBox(!showDiscountBox);
    setShowTaxBox(false);
  };
  // handle delete service
  const deleteService = (index) => {
    const updatedServices = [...services];
    updatedServices.splice(index, 1);
    setServices(updatedServices);
  };
  // handle delete payment
  const deletePayment = (index) => {
    const updatedPayments = [...payments];
    updatedPayments.splice(index, 1);
    setPayments(updatedPayments);
  };
  const handlePropagation = (e) => {
    e.stopPropagation();
  };
  const toggleDueDateBox = (index) => {
    if (smartdate) {
      const updatedPayments = [...payments];
      updatedPayments[index].dueDate = smartday + " " + smartmonth + " " + smartyear;
      updatedPayments[index].type = 'smartdate';
      updatedPayments[index].smartdays = smartday;
      updatedPayments[index].timetype = smartmonth;
      updatedPayments[index].smartdirection = smartyear;
      setPayments(updatedPayments);
      //setsmartdate(true);
    }
    setShowDueDateBox((prevIndex) => (prevIndex !== index ? index : null));
  };

  const handleDateChange = (event, index) => {
    let currentDate = new Date();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let options = {
      timeZone: timeZone, // Specify your timezone
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const inputDate = event.target.value + "T00:00:00";
    const newDueDate = new Date(inputDate);

    /*
        const dt = new Date();
        let diffTZ = dt.getTimezoneOffset();
    
        const localTime = newDueDate.getTime();
    const localOffset = newDueDate.getTimezoneOffset() * 60000;
    const utc = localTime + localOffset;
    const offset =  diffTZ; // UTC of USA Eastern Time Zone is -05.00
    const usa = utc + (3600000 * offset);
     const newDueDate1 = new Date(usa);
    
    */

    ///newDueDate=usaTimeNow;


    if (isNaN(newDueDate)) {
      console.error("Invalid date:", inputDate);
      return;
    }

    const formattedDueDate = newDueDate.toLocaleString("en-US", options);


    const updatedPayments = [...payments];

    var y = currentDate.getFullYear();
    var m = currentDate.getMonth();
    var d = currentDate.getDate();

    var y2 = newDueDate.getFullYear();
    var m2 = newDueDate.getMonth();
    var d2 = newDueDate.getDate();

    var comparedate1 = new Date(y, m, d);
    var comparedate2 = new Date(y2, m2, d2);


    if (comparedate2 > comparedate1) {
      // upcoming date
    } else if (comparedate2 < comparedate1) {
      // overdue date
    } else {
      // due today
    }
    updatedPayments[index].dueDate = formattedDueDate;
    updatedPayments[index].type = '';
    updatedPayments[index].smartdays = '';
    updatedPayments[index].timetype = '';
    updatedPayments[index].smartdirection = '';
    setPayments(updatedPayments);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        selectItemBoxRef.current &&
        !selectItemBoxRef.current.contains(event.target)
      ) {
        setIsSelectItemBoxOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectItemBoxRef]);

  const changeqty = (e, index) => {
    // alert(e.target.value);
    const updatedServices = [...services];
    updatedServices[index].qty = e.target.value;
    updatedServices[index].itemtotalprice =
      updatedServices[index].price * e.target.value;
    setServices(updatedServices);
    setIsSelectItemBoxOpen(!isSelectItemBoxOpen);
  };

  const pakageset = (e, index, packagedetail) => {
    // alert(parseInt(packagedetail.quantity));
    const updatedServices = [...services];
    updatedServices[index].qty = 1;
    updatedServices[index].price = parseFloat(packagedetail.price);
    updatedServices[index].type = packagedetail.name;
    updatedServices[index].descp = packagedetail.description;
    updatedServices[index].unit_option = packagedetail.unit_option;
    updatedServices[index].itemtotalprice = parseFloat(packagedetail.price);
    setServices(updatedServices);
    setIsSelectItemBoxOpen(!isSelectItemBoxOpen);
    toggleHandleServiceInfo(index);
    handleInput(e);
  };

  const handleSelectedValueChange = (value, indexval) => {
    // setSelectedValue(value);
    //alert(indexval);
    const updatedServices = [...services];
    updatedServices[indexval].unit_option = value;
    setServices(updatedServices);
    setIsSelectItemBoxOpen(!isSelectItemBoxOpen);
  };

  const handleOptionSelectsmartmonth = (value) => {
    setsmartmonth(value);
  };

  const handleOptionSelectsmartyear = (value) => {
    setsmartyear(value);
  };

  const handleOptionSelect = (value) => {
    // alert(value);

    if (value == "Smart date") {
      // alert('dhirendra');
      setsmartdate(true);
    } else {
      setsmartdate(false);
    }
  };

  const changeprice = (e, index) => {
    // alert(e.target.value);
    const updatedServices = [...services];
    updatedServices[index].price = e.target.value;
    updatedServices[index].itemtotalprice =
      updatedServices[index].qty * e.target.value;
    setServices(updatedServices);
    setIsSelectItemBoxOpen(!isSelectItemBoxOpen);
  };

  const changetype = (e, index) => {
    // alert(e.target.value);
    const updatedServices = [...services];
    updatedServices[index].type = e.target.value;
    setServices(updatedServices);
    setIsSelectItemBoxOpen(!isSelectItemBoxOpen);
  };

  const changedesc = (e, index) => {
    // alert(e.target.value);
    const updatedServices = [...services];
    updatedServices[index].descp = e.target.value;
    setServices(updatedServices);
    setIsSelectItemBoxOpen(!isSelectItemBoxOpen);
  };

  useEffect(() => {
    let sum = services.reduce(function (prev, current) {
      return prev + parseFloat(current.itemtotalprice || 0);
    }, 0);

    setsubtotalprice(Math.round(sum * 100) / 100);

    // Use local 'sum' variable instead of 'subtotalprice' state to avoid stale state
    let calculatedTotal = sum;
    let taxValue = 0;
    let discountValue = 0;

    if (taxper) {
      taxValue = Math.round((tax * sum / 100) * 100) / 100;
      calculatedTotal = sum + taxValue;
    } else {
      taxValue = Math.round(parseFloat(tax || 0) * 100) / 100;
      calculatedTotal = sum + taxValue;
    }
    settaxval(taxValue);

    if (discountper) {
      discountValue = Math.round((discount * sum / 100) * 100) / 100;
      calculatedTotal = calculatedTotal - discountValue;
    } else {
      discountValue = Math.round(parseFloat(discount || 0) * 100) / 100;
      calculatedTotal = calculatedTotal - discountValue;
    }
    setdiscountval(discountValue);

    settotalprice(Math.round(calculatedTotal * 100) / 100);

    // Recalculate payment amounts based on total (fix for $0 bug)
    if (payments.length && calculatedTotal > 0) {
      const perRowPayment = calculatedTotal / payments.length;
      const needsUpdate = payments.some(p => p.amount === 0 || p.amount === '0' || !p.amount);
      if (needsUpdate) {
        const newPayments = payments.map((payment) => ({
          ...payment,
          amount: Math.round(perRowPayment * 100) / 100
        }));
        setPayments(newPayments);
      }
    }

    // alert(sum);
  }, [services, tax, discount, discountper, taxper]);

  return (
    <>
      {" "}
      <section className="section_container">
        {/* Customer Details here */}
        <div className="customer_details left">
          {/* Customer info */}

          {secondarylogo ? (
            <>
              <div className="logo text-center" style={{ borderRadius: 0 }}>
                <img
                  src={secondarylogo}
                  alt="Main Logo Preview"
                  className="mainimgpath "
                  style={{ height: "150px" }}
                />
              </div>
            </>
          ) : (
            <></>
          )}

          <div className="title">
            <h4>{companyname}</h4>
          </div>
          <div
            className="item"
            style={{
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
            }}
          >
            <span
              style={{ textTransform: "capitalize", wordBreak: "break-word" }}
            >
              {fname} {lname}
            </span>
            <span style={{ wordBreak: "break-word" }}>{phone}</span>
            <span style={{ wordBreak: "break-word" }}>{companyemail}</span>
          </div>
        </div>

        {/* Invoice content */}
        <div className="invoice">
          <h3 style={{ margin: "0px 40px" }}>Invoice</h3>

          {/* invoice table */}
          <div className="invoice-table d-flex align-items-center flex-wrap justify-content-between mt-4">
            <div
              className="table_item  invoice_td position-relative"
              type="button"
              style={{ textAlign: "left" }}
            >
              <span className="hover_effect">Bill to</span>
              <br />
              <span> {username}</span>
              <br />
              <br />
              <br />
              <br />
            </div>
            <div
              className="table_item  invoice_td position-relative"
              type="button"
              style={{ marginRight: "6%", textAlign: "left" }}
            >
              <span className="hover_effect">invoice #</span>
              <br />
              <span>{code}</span> <br /> <br />
              <span>Date Issued</span> <br />
              {formattedDate}
            </div>

            <div
              className="table_item  purchase_td position-relative"
              style={{ marginRight: "1%", textAlign: "left" }}
            >
              <span className="hover_effect">Purchase order #</span>
              <br />
              <span>{props.purchageorder}</span>
              <br />
              <br />
              <span>Next Payment Due</span> <br />
              {(() => {
                const nextPayment = payments.find(p => p.status !== 'Paid') || payments[0];
                if (!nextPayment) return "";
                if (nextPayment.type === "smartdate" && nextPayment.smartdays && props.eventDate) {
                  const baseDate = new Date(props.eventDate);
                  const days = parseInt(nextPayment.smartdays);
                  const dir = nextPayment.smartdirection || nextPayment.dueDate || nextPayment.paymentId || '';
                  const isBefore = dir.includes("before");
                  switch (nextPayment.timetype?.toLowerCase()) {
                    case "day(s)": baseDate.setUTCDate(baseDate.getUTCDate() + (isBefore ? -days : days)); break;
                    case "week(s)": baseDate.setUTCDate(baseDate.getUTCDate() + (isBefore ? -days * 7 : days * 7)); break;
                    case "month(s)": baseDate.setUTCMonth(baseDate.getUTCMonth() + (isBefore ? -days : days)); break;
                    default: break;
                  }
                  return baseDate.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" });
                }
                return nextPayment.dueDate || "";
              })()}
            </div>
          </div>

          <div className="invoice-table d-flex align-items-center flex-wrap justify-content-between mt-4">
            <div></div>
            <div className="table_item table_item_date_issued position-relative">
              <div
                className="date position-absolute"
                style={{ fontSize: "14px" }}
              ></div>
            </div>
            <div className="table_item position-relative">
              <br />
              <div
                className="date position-absolute"
                style={{ fontSize: "14px" }}
              ></div>
            </div>
          </div>

          {/* service area */}
          <div className="service_area d-flex align-items-center justify-content-between py-3">
            <div className="service_item">
              <div className="service_info_top">
                <span>SERVICE INFO</span>
              </div>
            </div>
            <div className="service_item d-flex align-items-center">
              <span className="me-5">QTY</span>
              <span>UNIT</span>
            </div>
            <div className="service_item">
              <span className="me-3">
                {" "}
                {/*TAX*/}&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;{" "}
              </span>
              <span>PRICE</span>
            </div>
          </div>

          {/* create new service */}
          {/* Render dynamic services */}
          {services.map((service, index) => (
            <div
              key={index}
              className="create_new_service flex-wrap d-flex align-items-center justify-content-between py-3 position-relative"
            >
              <div className="service_item position-relative">
                <div className="service_info_box" style={{ marginTop: "41px" }}>
                  <div className="service_info">
                    <input
                      type="text"
                      id={`name-${index}`}
                      placeholder="Type or Select a Service"
                      value={service.type}
                      disabled
                      style={{ background: "none" }}
                    />
                    <small></small>
                  </div>
                  <div className="desc mt-2">
                    {" "}
                    &nbsp;
                    {/* <textarea name="" className="textare" placeholder='Enter a description' value={service.descp}  onChange={(e) => changedesc(e,index)}></textarea> */}
                    {/* <input type='text' placeholder='Enter a description' value={service.descp}  onChange={(e) => changedesc(e,index)} /> */}
                  </div>
                </div>

                {/* Select item */}
                {service?.showServiceInfo && (
                  <div className="select_item_box" ref={selectItemBoxRef}>
                    {/* nav item */}
                    <ul
                      className="nav nav-pills justify-content-between mb-3"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          id="pills-home-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-home"
                          type="button"
                          role="tab"
                          aria-controls="pills-home"
                          aria-selected="true"
                        >
                          All
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="pills-profile-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-profile"
                          type="button"
                          role="tab"
                          aria-controls="pills-profile"
                          aria-selected="false"
                        >
                          Package
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="pills-contact-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-contact"
                          type="button"
                          role="tab"
                          aria-controls="pills-contact"
                          aria-selected="false"
                        >
                          Items
                        </button>
                      </li>
                    </ul>

                    {/* Tab content */}
                    <div className="tab-content" id="pills-tabContent">
                      <div
                        className="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                        tabIndex="0"
                      >
                        <div className="tab_box_item px-3 py-3">
                          <div className="row">
                            {/* single item */}

                            {pakagesdetails.map((pakagesdetail, index2) => (
                              <div
                                className="col-md-12 pointer"
                                onClick={(e) =>
                                  pakageset(e, index, pakagesdetail)
                                }
                              >
                                <div className="d-flex justify-content-between mt-3">
                                  <div className="single_item">
                                    <h5>{pakagesdetail.name}</h5>

                                    <div className="d-flex align-items-center mt-2 cart_item">
                                      {/*  <i
                                      className='fa fa-cart-plus me-2'
                                      aria-hidden='true'></i>
                                    <p className='m-0'>{pakagesdetail.description}</p> */}
                                    </div>
                                  </div>

                                  {/* Price area */}
                                  <div>
                                    <h6>${pakagesdetail.price}</h6>
                                  </div>
                                </div>
                              </div>
                            ))}

                            {itemdetails.map((itemdetail, index2) => (
                              <div
                                className="col-md-12 pointer"
                                onClick={(e) => pakageset(e, index, itemdetail)}
                              >
                                <div className="d-flex justify-content-between mt-3">
                                  <div className="single_item">
                                    <h5>{itemdetail.name}</h5>

                                    <div className="d-flex align-items-center mt-2 cart_item">
                                      {/* <i
                                              className='fa fa-cart-plus me-2'
                                              aria-hidden='true'></i>
                                            <p className='m-0'>{itemdetail.description}</p>  */}
                                    </div>
                                  </div>

                                  {/* Price area */}
                                  <div>
                                    <h6>$ {itemdetail.price}</h6>
                                  </div>
                                </div>
                              </div>
                            ))}

                            {/* single item */}
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="pills-profile"
                        role="tabpanel"
                        aria-labelledby="pills-profile-tab"
                        tabIndex="0"
                      >
                        <div className="tab_box_item px-3 py-3">
                          <div className="row">
                            {/* single item */}

                            {pakagesdetails.map((pakagesdetail, index2) => (
                              <div
                                className="col-md-12 pointer"
                                onClick={(e) =>
                                  pakageset(e, index, pakagesdetail)
                                }
                              >
                                <div className="d-flex justify-content-between mt-3">
                                  <div className="single_item">
                                    <h5>{pakagesdetail.name}</h5>

                                    <div className="d-flex align-items-center mt-2 cart_item">
                                      {/*        <i
                                                                                className='fa fa-cart-plus me-2'
                                                                                aria-hidden='true'></i>
                                                                              <p className='m-0'>{pakagesdetail.description}</p>

                                                                              */}
                                    </div>
                                  </div>

                                  {/* Price area */}
                                  <div>
                                    <h6>${pakagesdetail.price}</h6>
                                  </div>
                                </div>
                              </div>
                            ))}

                            {/* single item */}
                            {/*
                            <div className='col-md-12 mt-3'>
                              <div className='d-flex justify-content-between mt-3'>
                                <div className='single_item'>
                                  <h5>
                                    Firefly Photo Booth <br /> 2 Hour Rental
                                  </h5>

                                  <div className='d-flex align-items-center mt-2 cart_item'>
                                    <i
                                      className='fa fa-cart-plus me-2'
                                      aria-hidden='true'></i>
                                    <p className='m-0'>package template</p>
                                  </div>
                                </div>   */}

                            {/* Price area */}
                            {/* <div>
                                  <h6>$400</h6>
                                </div>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="pills-contact"
                        role="tabpanel"
                        aria-labelledby="pills-contact-tab"
                        tabIndex="0"
                      >
                        <div className="tab_box_item px-3 py-3">
                          <div className="row">
                            {/* single item */}

                            {itemdetails.map((itemdetail, index2) => (
                              <div
                                className="col-md-12 pointer"
                                onClick={(e) => pakageset(e, index, itemdetail)}
                              >
                                <div className="d-flex justify-content-between mt-3">
                                  <div className="single_item">
                                    <h5>{itemdetail.name}</h5>

                                    <div className="d-flex align-items-center mt-2 cart_item">
                                      {/* <i
                                              className='fa fa-cart-plus me-2'
                                              aria-hidden='true'></i>
                                            <p className='m-0'>{itemdetail.description}</p>  */}
                                    </div>
                                  </div>

                                  {/* Price area */}
                                  <div>
                                    <h6>$ {itemdetail.price}</h6>
                                  </div>
                                </div>
                              </div>
                            ))}

                            {/* single item */}

                            {/* single item */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="service_item d-flex align-items-center">
                {/* QYT field */}
                <span className="me-2 qyt">
                  <input
                    type="text"
                    placeholder="QYT"
                    value={service.qty}
                    disabled
                  />
                </span>

                {/* UNIT Field */}
                <span className="position-relative">
                  <UnitOption
                    onChange={handleSelectedValueChange}
                    indexval={index}
                    rawselectedOption={service.unit_option}
                  />
                </span>
              </div>
              <div className="service_item d-flex align-items-center">
                <div className="form-check ">
                  {/* <input
                                className='form-check-input'
                                type='checkbox'
                                name='tax'
                                value=''
                                id='flexCheckDefault'
                                checked={service.tax ? 'checked' : ''}
                              /> */}
                </div>
                <div className="form-check qyt">
                  <input
                    type="text"
                    placeholder="Price"
                    value={service.price}
                    disabled
                  />
                  <small></small>
                </div>
              </div>

              {/* Delete button */}
              <div className="position-absolute delete_btn"></div>

              <div className="textare2 left">
                <textarea
                  ref={(el) => (ref2.current[index] = el)}
                  placeholder="Enter a description"
                  rows={1}
                  onInput={(e) => handleInput(e, index)}
                  name={index}
                  id={`desc-${index}`}
                  className="textare3"
                  value={service.descp}
                  disabled
                  style={{ borderBottom: "none !important" }}
                />
                <small></small>
              </div>
            </div>
          ))}

          {/* Summary*/}
          <div className="card-body">
            <div className="row flex-column-reverse flex-md-row row-gap-4 row-gap-md-0">
              <div className="col-md-5 d-flex align-items-end"></div>

              <div className="col-md-7 ml-auto">
                <table className="table create_invoice_table table-clear">
                  <tbody>
                    <tr>
                      <td className="left">
                        <span>Subtotal</span>
                      </td>
                      <td className="right">${(Number(subtotalprice) || 0).toFixed(2)}</td>
                    </tr>
                    {/* Tax box */}
                    <tr>
                      <td className="left position-relative">
                        <span className="pointer">
                          Tax {/* <span>8.5%</span> */}
                        </span>
                        {showTaxBox && (
                          <div className="edit_discount_box edit_tax_box position-relative">
                            <div className="box_header d-flex align-items-center justify-content-between mb-2">
                              <h5>Edit Tax</h5>
                              <span onClick={() => setShowTaxBox(false)}>
                                <i className="fas fa-close"></i>
                              </span>
                            </div>
                            <div className="box-content mt-2 d-flex align-items-center">
                              <input
                                type="number"
                                className="me-2"
                                placeholder="Tax"
                                value={tax}
                                onChange={(e) => settax(e.target.value)}
                              />

                              <div className="input-group">
                                <span
                                  className={`input-group-text ${
                                    taxper ? "taxgreen" : ""
                                  }`}
                                  id="basic-addon1"
                                  onClick={() => settaxper(true)}
                                >
                                  %
                                </span>
                                <span
                                  className={`input-group-text ${
                                    taxper ? "" : "taxgreen"
                                  }`}
                                  id="basic-addon1"
                                  onClick={() => settaxper(false)}
                                >
                                  $
                                </span>
                              </div>

                              {/* delete button */}
                              <div>
                                {" "}
                                <i
                                  className="fas fa-trash text-danger"
                                  onClick={() => settax(0)}
                                ></i>
                              </div>
                            </div>

                            <div className="discount_arrow"></div>
                          </div>
                        )}
                      </td>
                      <td className="right">${(Number(taxval) || 0).toFixed(2)}</td>
                    </tr>

                    {/* add discount box */}
                    <tr>
                      <td className="left position-relative">
                        {showDiscountBox ? (
                          <span className="pointer">Discount</span>
                        ) : (
                          <span className="pointer">Add Discount</span>
                        )}

                        {/* edit discount box */}
                        {showDiscountBox && (
                          <div className="edit_discount_box position-relative">
                            <div className="box_header d-flex align-items-center justify-content-between mb-2">
                              <h5>Edit Discount</h5>
                              <span onClick={() => setShowDiscountBox(false)}>
                                <i className="fas fa-close"></i>
                              </span>
                            </div>
                            <div className="box-content mt-2 d-flex align-items-center">
                              <input
                                type="number"
                                className="me-2"
                                value={discount}
                                onChange={(e) => setdiscount(e.target.value)}
                              />

                              <div className="input-group">
                                <span
                                  className={`input-group-text ${
                                    discountper ? "taxgreen" : ""
                                  }`}
                                  id="basic-addon1"
                                  onClick={() => setdiscountper(true)}
                                >
                                  %
                                </span>
                                <span
                                  className={`input-group-text ${
                                    discountper ? "" : "taxgreen"
                                  }`}
                                  id="basic-addon1"
                                  onClick={() => setdiscountper(false)}
                                >
                                  $
                                </span>
                              </div>

                              {/* delete button */}
                              <div>
                                {" "}
                                <i
                                  className="fas fa-trash text-danger"
                                  onClick={() => setdiscount(0)}
                                ></i>
                              </div>
                            </div>

                            <div className="discount_arrow"></div>
                          </div>
                        )}
                      </td>
                      <td className="right">
                        <strong>${(Number(discountval) || 0).toFixed(2)}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td className="left">
                        <span>Total USD</span>
                      </td>
                      <td className="right">
                        <strong>{(Number(totalprice) || 0).toFixed(2)}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* PAYMENT SCHEDULE */}
      <section className="section_container my-4 px-2 px-md-5 py-5">
        <div className="title">
          <h4>PAYMENT SCHEDULE</h4>
        </div>

        <div className="payment_schedule_container mt-2">
          <table>
            <thead>
              <tr>
                <th scope="col" style={{ width: "74px" }}>
                  AMOUNT
                </th>
                <th scope="col">DUE DATE</th>
                <th scope="col">PAYMENT DATE</th>
                <th scope="col">PAYMENT ID</th>
                <th scope="col" style={{ width: "74px" }}>
                  STATUS
                </th>
              </tr>
            </thead>
            <tbody>
              {payments.map((data, i) => {
                // Step 1: Base event date in UTC
                const firstDate = props.eventDate
                  ? new Date(props.eventDate) // assume ISO string from DB
                  : new Date();

                let actualDueDate;

                if (data.type === "smartdate" && data.smartdays) {
                  // Always work in UTC
                  let baseDate = new Date(firstDate.getTime());
                  const days = parseInt(data.smartdays);
                  // Get direction from smartdirection field, or fallback to dueDate/paymentId text (backward compat)
                  const directionSource = data.smartdirection || data.dueDate || data.paymentId || '';
                  const isBefore = directionSource.includes("before");

                  switch (data.timetype?.toLowerCase()) {
                    case "day(s)":
                      baseDate.setUTCDate(
                        baseDate.getUTCDate() +
                          (isBefore ? -days : days)
                      );
                      break;
                    case "week(s)":
                      baseDate.setUTCDate(
                        baseDate.getUTCDate() +
                          (isBefore
                            ? -days * 7
                            : days * 7)
                      );
                      break;
                    case "month(s)":
                      baseDate.setUTCMonth(
                        baseDate.getUTCMonth() +
                          (isBefore ? -days : days)
                      );
                      break;
                    default:
                      break;
                  }

                  // Format to UTC to avoid off-by-one
                  actualDueDate = baseDate.toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                    timeZone: "UTC",
                  });
                } else {
                  actualDueDate = new Date(data.dueDate).toLocaleDateString(
                    "en-US",
                    {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                      timeZone: "UTC", // force UTC
                    }
                  );
                }

                return (
                  <tr key={i}>
                    <td data-label="Amount">
                      <span className="hover_item">${(Number(data.amount) || 0).toFixed(2)}</span>
                    </td>

                    <td
                      data-label="DUE DATE"
                      className="due_date hover_payment position-relative"
                    >
                      <span className="hover_item">
                        {actualDueDate}

                        {showDueDateBox === i && (
                          <div
                            className="due_date_box"
                            onClick={handlePropagation}
                          >
                            <div className="due_date_box_header d-flex align-items-center justify-content-between">
                              <h4>Set Payment Due</h4>
                              <span onClick={() => toggleDueDateBox(i)}>
                                <i className="fas fa-close"></i>
                              </span>
                            </div>
                            <div className="arrow"></div>

                            <div className="due_date_box_content mt-2">
                              {smartdate ? (
                                <CommonDropdownMenuThree
                                  options={options}
                                  suboption={options_sub}
                                  handleOptionSelect={handleOptionSelect}
                                  rawselectedOption={options[1]}
                                />
                              ) : (
                                <CommonDropdownMenuThree
                                  options={options}
                                  suboption={options_sub}
                                  handleOptionSelect={handleOptionSelect}
                                  rawselectedOption={options[0]}
                                />
                              )}

                              {smartdate && (
                                <div className="d-flex smartdate">
                                  <input
                                    className="smardatinp"
                                    value={smartday}
                                    onChange={(e) =>
                                      setsmartday(e.target.value)
                                    }
                                  />
                                  &nbsp;
                                  <CommonDropdownMenufour
                                    options={options2}
                                    handleOptionSelect={
                                      handleOptionSelectsmartmonth
                                    }
                                    rawselectedOption={options2[0]}
                                  />
                                  &nbsp;
                                  <CommonDropdownMenufour
                                    options={options3}
                                    handleOptionSelect={
                                      handleOptionSelectsmartyear
                                    }
                                    rawselectedOption={options3[0]}
                                  />
                                </div>
                              )}

                              {!smartdate && (
                                <div className="mt-3 date_input">
                                  <input
                                    type="date"
                                    onChange={(event) =>
                                      handleDateChange(event, i)
                                    }
                                    value={
                                      data.dueDate
                                        ? new Date(data.dueDate)
                                            .toISOString()
                                            .split("T")[0]
                                        : ""
                                    }
                                  />
                                </div>
                              )}

                              <div className="mt-3 text-end">
                                <button onClick={() => toggleDueDateBox(i)}>
                                  Save
                                </button>
                              </div>
                            </div>

                            <div className="arrow"></div>
                          </div>
                        )}
                      </span>
                    </td>

                    <td data-label="PAYMENT DATE">
                      {data.paid_at === "-"
                        ? data.paid_at
                        : new Date(data.paid_at).toLocaleDateString("en-US", {
                            timeZone: "UTC",
                          })}
                    </td>
                    <td data-label="PAYMENT ID">{String(data.paymentId ?? '').startsWith('PAY-') ? data.paymentId : code}</td>
                    <td
                      data-label="STATUS"
                      className="text-end position-relative"
                      style={{ cursor: "pointer" }}
                    >
                      {data.status}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {/* add new payment button  */}
        <div className="add-new-payment py-5"></div>
      </section>
      {/* hidden div for style */}
      <div className=" my-2 px-5 py-2 invisible"></div>
    </>
  );
});

export default React.memo(CreateInvoiceContent);
